import { makeReverseTComposable } from "@saflib/vue";
import { powerUpCommonStrings } from "./strings.ts";

export const { useReverseT } = makeReverseTComposable(powerUpCommonStrings);
